import { useControllableValue } from 'ahooks';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { isNone } from '../_util/defineType';
import insertRipple from '../_util/insertRipple';
import { pickDomAttrs } from '../_util/utils';
import Explain from '../explain';
import { useConfig } from '../hooks/useConfig';
import Tag from '../tag';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// function fixEmojiLength(value: string, maxLength: number) {
//   return [...(value || '')].slice(0, maxLength).join('');
// }

const Textarea = props => {
  const {
    type = 'outline',
    label,
    placeholder,
    width = 300,
    height = 100,
    disabled = false,
    error,
    readonly,
    showCount,
    maxLength,
    onChange,
    onFocus,
    onBlur,
    onKeyDown,
    assist,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    wrapClassName,
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-textarea");
  const attrs = pickDomAttrs(restProps);
  const {
    locale: {
      Textarea: TextareaLocale
    }
  } = useConfig();
  const [value, setValue] = useControllableValue(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  const textareaRef = useRef(null);
  const hasMaxLength = maxLength && Number(maxLength) > 0;
  const canDoSomething = !disabled && !readonly;
  return /*#__PURE__*/_jsx(Explain, {
    ...attrs.data,
    helperText: error === true ? undefined : error,
    wrapClassName: wrapClassName,
    children: /*#__PURE__*/_jsxs("div", {
      className: classNames(className, baseClassName, {
        ["".concat(baseClassName, "-").concat(type)]: type,
        disabled: !!disabled,
        readonly: !!readonly,
        error: !!error
      }),
      style: {
        width,
        height,
        ...style
      },
      ref: ref => {
        insertRipple({
          ref
        });
      },
      onClick: () => {
        if (canDoSomething) {
          var _textareaRef$current;
          (_textareaRef$current = textareaRef.current) === null || _textareaRef$current === void 0 || _textareaRef$current.focus();
        }
      },
      children: [!isNone(label) && /*#__PURE__*/_jsx("div", {
        className: "label",
        children: label
      }), /*#__PURE__*/_jsx("textarea", {
        ref: textareaRef,
        className: "".concat(baseClassName, "--input"),
        placeholder: placeholder,
        disabled: !canDoSomething,
        value: value || '',
        onFocus: e => {
          onFocus === null || onFocus === void 0 || onFocus(e.target.value, e);
        },
        onBlur: e => {
          onBlur === null || onBlur === void 0 || onBlur(e.target.value, e);
        },
        onChange: e => {
          const value = e.currentTarget.value;
          if (hasMaxLength) {
            setValue(value.slice(0, maxLength));
          } else {
            setValue(value);
          }
        },
        onKeyDown: e => !!onKeyDown && onKeyDown(value, e)
      }), (!!(assist !== null && assist !== void 0 && assist.length) || showCount) && /*#__PURE__*/_jsxs("div", {
        className: "footer",
        children: [!!(assist !== null && assist !== void 0 && assist.length) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "assistLabel",
            children: TextareaLocale.assistLabel
          }), /*#__PURE__*/_jsx("div", {
            className: "assistContent",
            children: assist === null || assist === void 0 ? void 0 : assist.map(i => /*#__PURE__*/_jsx(Tag, {
              disabled: disabled,
              className: "assistTag",
              onClick: () => {
                if (canDoSomething) {
                  const val = (value || '') + i;
                  if (hasMaxLength) {
                    setValue(value.slice(0, maxLength));
                  } else {
                    setValue(val);
                  }
                }
              },
              children: i
            }, i))
          })]
        }), showCount && /*#__PURE__*/_jsx("div", {
          className: "count",
          children: /*#__PURE__*/_jsxs("div", {
            children: [(value === null || value === void 0 ? void 0 : value.length) || 0, maxLength ? " / ".concat(maxLength) : undefined]
          })
        })]
      })]
    })
  });
};
export default Textarea;